<template>
  <div>
    <DataTable
      :rowKeys="['id']"
      :rows="conductorApis"
      :actions="[
        {
          name: 'workflowList',
          label: 'Go',
          params: { id: 'conductorApiId' }
        }
      ]"
      :columns="[
        { name: 'id', type: 'text' },
        { name: 'url', type: 'text' },
        { name: 'readOnly', type: 'boolean' },
        { name: 'color', type: 'color' }
      ]"
    />
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'ConductorApiList',
  props: {
    conductorApis: Array
  },
  components: {
    DataTable
  }
}
</script>
